import { render, staticRenderFns } from "./ProjectsOverallFinal.vue?vue&type=template&id=4af7d340&"
import script from "./ProjectsOverallFinal.vue?vue&type=script&lang=js&"
export * from "./ProjectsOverallFinal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4af7d340')) {
      api.createRecord('4af7d340', component.options)
    } else {
      api.reload('4af7d340', component.options)
    }
    module.hot.accept("./ProjectsOverallFinal.vue?vue&type=template&id=4af7d340&", function () {
      api.rerender('4af7d340', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components-globalwork/ProjectsOverallFinal.vue"
export default component.exports